"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var isNativeCSSSupportsAvailable = (0, lodash_1.has)(global, 'CSS.supports');
var FEATURE_RULE_SETS = {
    MULTILINE_CLAMP: {
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
    },
};
var FeatureDetector = /** @class */ (function () {
    function FeatureDetector() {
        var _this = this;
        this.isRuleSetAvailable = (0, lodash_1.memoize)(this._isRuleSetAvailable, JSON.stringify);
        this.isMultilineClampAvailable = function () {
            return _this.isRuleSetAvailable(FEATURE_RULE_SETS.MULTILINE_CLAMP);
        };
        this.isRuleSetAvailable.cache = new Map();
    }
    FeatureDetector.prototype._isRuleSetAvailable = function (rules) {
        if (isNativeCSSSupportsAvailable) {
            return (0, lodash_1.every)(rules, function (value, rule) {
                return global.CSS.supports(rule, value);
            });
        }
        var element = document.createElement('div');
        element.style.position = 'absolute';
        element.style.zIndex = '-1';
        document.body.appendChild(element);
        (0, lodash_1.forEach)(rules, function (value) { return (element.style.rule = value); });
        var computedStyle = getComputedStyle(element);
        var areAllApplied = (0, lodash_1.every)(rules, function (value, rule) {
            return computedStyle[rule] === value;
        });
        document.body.removeChild(element);
        return areAllApplied;
    };
    return FeatureDetector;
}());
exports.default = new FeatureDetector();
//# sourceMappingURL=feature-detector.js.map